import React, { createContext, useState } from 'react'
import PropTypes from 'prop-types'
import { getFromLocalStorage } from '../helper/storage'
export const BrandContext = createContext()
export function BrandProvider(props) {
  const [brandData, setBrandData] = useState(
    getFromLocalStorage('brandData:') || null,
  )
  const [signupError, setSignupError] = useState(null)
  const [loginError, setLoginError] = useState(null)
  const [brandSuccess, setBrandSuccess] = useState(false)

  // console.log('success:', brandSuccess)

  return (
    <BrandContext.Provider
      value={{
        signupError,
        setSignupError,
        brandSuccess,
        setBrandSuccess,
        brandData,
        setBrandData,
        loginError,
        setLoginError,
      }}
    >
      {props.children}
    </BrandContext.Provider>
  )
}

BrandProvider.propTypes = {
  children: PropTypes.object,
}
